'use client';

import { FileText, XIcon } from 'lucide-react';
import type { FC } from 'react';
import { useS3Docs } from './S3DocContext';

export const S3DocChips: FC = () => {
	const { documents, removeDocument } = useS3Docs();

	if (documents.length === 0) return null;

	return (
		<div className="mb-2 flex w-full flex-row items-center gap-2 overflow-x-auto px-1.5 pb-1 pt-0.5">
			{documents.map((doc) => (
				<div
					className="relative flex h-16 max-w-48 items-center gap-2 overflow-hidden rounded-xl border border-foreground/20 bg-muted px-3"
					key={doc.documentId}
				>
					<FileText className="size-5 shrink-0 text-muted-foreground" />
					<div className="flex min-w-0 flex-col">
						<span className="truncate text-sm text-foreground">{doc.name}</span>
						<span className="truncate text-xs text-muted-foreground">{doc.fileType}</span>
					</div>
					<button
						aria-label={`Remove ${doc.name}`}
						className="absolute right-1.5 top-1.5 flex size-3.5 items-center justify-center rounded-full bg-white shadow-sm hover:bg-white"
						onClick={() => removeDocument(doc.documentId)}
						type="button"
					>
						<XIcon className="size-3 text-destructive" />
					</button>
				</div>
			))}
		</div>
	);
};
